<template>
  <Base :base-id="'lb-order-transport'" :is-loading="dataIsLoad">
    <template #header>
      <h4 class="title">物流追蹤</h4>
    </template>
    <template #body>
      <ol class="progress-approval">
        <li v-for="(progress, index) in data.ShippingFlows" :key="index" class="progress-step">
          <div class="approver">
            <div class="time">
              <p>
                {{ progress.Date.substring(0, 11).replaceAll('-', '/') }}
                <span class="description">{{ progress.ShippingFlowDescription }}</span>
              </p>
              <p>
                {{ progress.Date.substring(11) }}
                <a
                  v-if="progress.ShippingFlowDescription === '準備中' && link"
                  target="_blank"
                  :href="link"
                  class="statusUrl"
                >
                  {{ shippingNumber }}
                </a>
              </p>
            </div>
          </div>
        </li>
      </ol>
    </template>
    <template #footer>
      <a href="#" class="btn btn-primary btn-block" @click="closeModal">確定</a>
    </template>
  </Base>
</template>

<script setup>
import { onMounted } from 'vue';
import { storeToRefs } from 'pinia';

import useShippingProgress from '@global/composable/order/useShippingProgress';
import useModalStore from '@global/stores/useModalStore';

import Base from '@global/components/common/modal/Base.vue';

const modalStore = useModalStore();
const { closeModal } = modalStore;
const { modalData } = storeToRefs(modalStore);

const { data, dataIsLoad, link, shippingNumber, fetchAPI } = useShippingProgress({
  transactionId: modalData.value.id,
  wmstransactionId: modalData.value.wid,
});

onMounted(() => {
  fetchAPI();
});
</script>
